import React, {useState} from 'react';
import Modal from '../../component/Inc/Modal';
function PopSetProduct(props) {
  const {open, close} = props;
  const [selectedItem, setSelectedItem] = useState(null);
  const listItems = [
    {id: 3214, title: '수시 상품명 상품명 5,000원'},
    {id: 3215, title: '수시 상품명 상품명 5,000원'},
    {id: 3216, title: '수시 상품명 상품명 5,000원'},
    {id: 3217, title: '수시 상품명 상품명 5,000원'},
    {id: 3218, title: '수시 상품명 상품명 5,000원'},
    {id: 3219, title: '수시 상품명 상품명 5,000원'},
    {id: 3220, title: '수시 상품명 상품명 5,000원'},
    {id: 3219, title: '수시 상품명 상품명 5,000원'},
    {id: 3219, title: '수시 상품명 상품명 5,000원'},
    {id: 3219, title: '수시 상품명 상품명 5,000원'}
  ];
  const handleClick = (index) => {
    setSelectedItem(index);
  };
  return (
    <Modal open={open} close={close} popSize="s" type="com_input pop_set_product">
      <h2 className="pop_tit">수시 세트 상품 등록</h2>
      <div className="content_container scroll">
        <table className="com_board_list type_row">
          <colgroup>
            <col width="148" />
            <col width="auto" />
          </colgroup>
          <tbody>
            <tr>
              <th>세트 상품명</th>

              <td>
                <input type="text" className="input" defaultValue={`논술 세트상품 60`} />
              </td>
            </tr>
          </tbody>
        </table>
        <div className="pop_tit_sub">상품 검색</div>
        <hr className="com_divider" />
        <div className="check com_radio_wrap">
          <input type="radio" name="rdo_1" id="rdo02" className="com_chk circle" />
          <label htmlFor="rdo02">논술</label>
          <input type="radio" name="rdo_1" id="rdo03" className="com_chk circle" />
          <label htmlFor="rdo03">생기부디자인</label>
          <input type="radio" name="rdo_1" id="rdo04" className="com_chk circle" />
          <label htmlFor="rdo04">정시컨설팅 </label>
          <input type="radio" name="rdo_1" id="rdo05" className="com_chk circle" />
          <label htmlFor="rdo05">수시컨설팅</label>
          <input type="radio" name="rdo_1" id="rdo06" className="com_chk circle" />
          <label htmlFor="rdo06">면접</label>
          <input type="radio" name="rdo_1" id="rdo07" className="com_chk circle" />
          <label htmlFor="rdo07">자소서</label>
        </div>
        <section className="com_board_search">
          <article className="search full">
            <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search full" />
            <button className="com_btn gray ws xs icon_search"></button>
          </article>
        </section>
        <ul className="com_scroll_list pick">
          {listItems.map((item, index) => (
            <li
              key={index}
              className={`item ${selectedItem === index ? 'selected' : ''}`} // 선택된 항목에 'selected' 클래스 추가
              onClick={() => handleClick(index)}
            >
              {item.title}
            </li>
          ))}
        </ul>
        <div className="com_btn_wrap center bottom">
          <button className="com_btn orange xs">추가</button>
        </div>
        <hr className="com_divider" />
        <div className="pop_tit_sub">
          수시 세트에 추가된 상품
          <button className="com_btn gray xxs">상품 삭제</button>
        </div>
        <table className="com_board_list">
          <colgroup>
            <col width="110" />
            <col width="auto" />
          </colgroup>
          <thead>
            <tr>
              <th>수업 순서 </th>
              <th>상품명</th>
            </tr>
          </thead>
          <tbody>
            {[...Array(5)].map((_, idx) => (
              <tr key={idx}>
                <td>
                  <div className="count_wrap">
                    <button className="arrow down"></button>
                    {idx + 1}
                    <button className="arrow up"></button>
                  </div>
                </td>
                <td>
                  <div className="product_row">
                    <span className="tit">수시상품명 </span>
                    <span className="des">25,000원</span>
                    <button className="btn_delete"></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="total_wrap">
          수시 세트 상품금액 : <span className="price">78,000</span>원
        </div>
        <hr className="com_divider" />
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">등록</button>
      </div>
    </Modal>
  );
}

export default PopSetProduct;
